export function toNumber(value: any, decimals: number = 0) : number {
    let compactValue = (typeof value == 'string') ? value.replace(/\s+/g, '') : value;
    compactValue = parseFloat(compactValue) || 0;

    let multiplier = Math.pow(10, decimals);
    return Math.round(compactValue * multiplier) / multiplier;
}
